import { render, staticRenderFns } from "./RaceTab.vue?vue&type=template&id=8a03441a&scoped=true&"
import script from "./RaceTab.vue?vue&type=script&lang=js&"
export * from "./RaceTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a03441a",
  null
  
)

export default component.exports